import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * SidebarHeader - Top section of sidebar for logo/branding
 */
export const SidebarHeader = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex h-16 overflow-hidden items-center border-b px-6',
      className
    )}
    {...props}
  />
));
SidebarHeader.displayName = 'SidebarHeader';
